/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type AuditActorType = "AGENT" | "USER" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type actorSection_auditEvent$ref: FragmentReference;
declare export opaque type actorSection_auditEvent$fragmentType: actorSection_auditEvent$ref;
export type actorSection_auditEvent = {|
  +actor: ?{|
    +name: ?string,
    +type: ?AuditActorType,
    +uuid: string,
    +node: ?{|
      +name?: string,
      +avatar?: {|
        +url: string
      |},
    |},
  |},
  +$refType: actorSection_auditEvent$ref,
|};
export type actorSection_auditEvent$data = actorSection_auditEvent;
export type actorSection_auditEvent$key = {
  +$data?: actorSection_auditEvent$data,
  +$fragmentRefs: actorSection_auditEvent$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "actorSection_auditEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditActor",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Avatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "User",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "Agent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuditEvent",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a39f5a31426b7e9fc84dc618d596ea73';

module.exports = node;
